import { ButtonIcon } from '@pets-ui/Button/ButtonIcon'
import { ButtonBase } from '@pets-ui/ButtonBase/ButtonBase'
import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowUpLarge } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { formatPrice } from '@utils'

export interface ButtonCampaignFooterAmountProps {
  amount?: number
  currency?: string
  onClick?: () => void
  shippingFee?: number
  discountTotalWithoutShippingCoupon?: number
}

export const ButtonCampaignFooterAmount = (props: ButtonCampaignFooterAmountProps) => {
  const { amount = 0, currency = '', onClick, shippingFee = 0, discountTotalWithoutShippingCoupon = 0 } = props
  return (
    <ButtonBase onClick={onClick} disableRipple>
      <VStack alignItems="flex-start">
        <HStack gap={1} alignItems="center">
          <Text variant="caption" color={colors.grey600}>
            明細
          </Text>
          <ButtonIcon>
            <ArrowUpLarge color={colors.grey600} fontSize={12} />
          </ButtonIcon>
          {discountTotalWithoutShippingCoupon > 0 && (
            <Chip size="xSmall" isOutlined variant="square" color="green">
              已省下
              {formatPrice(currency, discountTotalWithoutShippingCoupon)}
            </Chip>
          )}
        </HStack>
        <HStack alignItems="flex-end" gap={1}>
          <Text variant="caption" color={colors.grey600}>
            訂購總額
          </Text>
          <Text variant="h5">
            {formatPrice(currency, amount, ' $value')}
          </Text>
          {shippingFee > 0 && (
            <Text variant="caption" color={colors.grey600}>
              (含運
              {' '}
              {formatPrice(currency, shippingFee, ' $value')}
              )
            </Text>
          )}
        </HStack>
      </VStack>
    </ButtonBase>
  )
}
